import { AZURE_DEVOPS_SDK } from '@/utils/azure-devops-helpers/general'

const NO_PROJECT_CONTEXT = null

export const getAzureProjectContext = () => {
  if (!AZURE_DEVOPS_SDK) return NO_PROJECT_CONTEXT

  const { project } = AZURE_DEVOPS_SDK.getWebContext()

  return project || NO_PROJECT_CONTEXT
}
